export default __webpack_public_path__ + "static/media/kitchen4-afterE-1024w.23f59bca.webp";